import { render, staticRenderFns } from "./Defeated.vue?vue&type=template&id=271d22ca&scoped=true&"
import script from "./Defeated.vue?vue&type=script&lang=js&"
export * from "./Defeated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d22ca",
  null
  
)

export default component.exports